// set up a threshold for recommended budget to show up in the UI
const RECOMMENDED_BUDGET_DEVIATION = 0.1;

export function isBudgetLow (actualBudget, recommendedBudget) {
    if (actualBudget < recommendedBudget * (1 - RECOMMENDED_BUDGET_DEVIATION)) {
        return true;
    }
    return false;
}
